import { Link, type LinkProps } from 'react-router-dom';
import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { isInternalHref, toRoute } from '../lib/urls';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string; children: ReactNode };

export function SiteLink({ href = '#', children, ...props }: Props) {
  if (isInternalHref(href) && !props.download) {
    const linkProps = { ...props, to: toRoute(href) } as unknown as LinkProps;
    return <Link {...linkProps}>{children}</Link>;
  }
  return <a href={href} {...props}>{children}</a>;
}
